import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  button: {
    display: 'inline-flex',
    placeContent: 'center',
    columnGap: token.paddingXS,
    paddingBlock: token.paddingXS,
    width: 240,
    fontSize: token.fontSizeHeading5,
    fontWeight: token.fontWeightStrong,
    cursor: 'pointer',
    backgroundColor: token.colorPrimary,
    color: token.colorWhite,
    borderTopLeftRadius: token.borderRadiusXS,
    borderTopRightRadius: token.borderRadiusXS,
    [`&:hover`]: {
      backgroundColor: token.colorPrimaryHover
    }
  },
  group: {
    position: 'relative',
    width: 302,
    paddingInlineStart: '20px',
    paddingBlockEnd: token.paddingSM,
    color: token['blue-6'],

    [`&:before`]: {
      [`content`]: '""',
      position: 'absolute',
      width: '2px',
      height: '20px',
      top: '4px',
      insetInlineStart: '0px',
      background: token['blue-6']
    }
  },
  title: {
    paddingBlockEnd: token.paddingSM,
    margin: 0
  },
  items: {
    display: 'grid',
    gridTemplateColumns: '100px 100px 100px'
  },
  item: {
    paddingBlock: 2
  }
}))
